import React from "react";
import { useDarkMode } from "src/context/DarkModeContext";
import ExplanationCard from "src/components/cards/ExplanationCard/ExplanationCard";
import ConjugationTable from "src/components/tables/ConjugationTable";
import ExampleCard from "src/components/cards/ExampleCard/ExampleCard";
import PageStructure from "src/components/wrappers/PageStructure";
import ExampleTitle from "src/components/ExampleTitle";
import {
    futuroPerfectoExplanation,
    futuroPerfectoExamples,
    futuroPerfectoRegular,
    futuroPerfectoIrregular
} from "src/data/individual-topics/FuturePerfect";

const FuturoPerfectoContent: React.FC = () => {
    const { isDarkMode } = useDarkMode();

    return (
        <div className={`${isDarkMode ? "dark" : ""}`}>

            <div className="section">
                <ExplanationCard cardData={futuroPerfectoExplanation} />
            </div>

            <ExampleTitle />

            <div className="section" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {futuroPerfectoExamples.map((example, index) => (
                    <ExampleCard key={index} example={example} />
                ))}
            </div>

            <div className="section">
                <ConjugationTable tableData={futuroPerfectoRegular} />
            </div>

            <div className="section">
                <ConjugationTable tableData={futuroPerfectoIrregular} />
            </div>

        </div>
    );
};

const FuturoPerfectoScreen: React.FC = () => {
    return (
        <PageStructure
            TitleNode="Future Perfect"
            Page={<FuturoPerfectoContent />}
        />
    );
};

export default FuturoPerfectoScreen;
